import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html'
})
export class PageNotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/page-notfound/page-notfound.component.ts